import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-75f643be"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "complaint-layout"
};
const _hoisted_2 = {
  class: "scam-title"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "scam-hint-layout"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "scam-hint"
}, " 投诉描述 "), /*#__PURE__*/_createElementVNode("div", {
  class: "scam-hint",
  style: {
    "color": "red"
  }
}, " * ")], -1));
const _hoisted_4 = {
  class: "scam-content-layout"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "scam-hint-layout",
  style: {
    "margin-top": "40px"
  }
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "scam-hint"
}, " 手机号 ")], -1));
const _hoisted_6 = {
  class: "scam-content-layout"
};
const _hoisted_7 = {
  style: {
    "margin": "20px"
  }
};
import { onMounted, ref } from "vue";
import { useRoute } from "vue-router";
import axios from "axios";
import { showFailToast, showSuccessToast } from "vant";
export default {
  __name: 'ComplaintScamComponents',
  props: {
    title: String
  },
  setup(__props) {
    const route = useRoute();
    const complaintId = route.params.complaintId;
    const message = ref('');
    const phoneNo = ref('');
    const prop = __props;
    onMounted(() => {
      document.title = prop.title;
    });
    const submit = () => {
      if (message.value.length > 0) {
        const phoneReg = /^1[3-9]\d{9}$/;
        if (phoneNo.value.length > 0 && !phoneReg.test(phoneNo.value)) {
          showFailToast('手机号校验失败，请重新填写');
          return;
        }
        axios.post(`https://server.huichangliang.com/livecode/newComplaint`, {
          "complaintId": complaintId,
          "complaintTitle": prop.title,
          "complaintContent": message.value,
          "complaintPhone": phoneNo.value
        }).then(s => {
          console.log('ssss', s);
          const {
            status,
            data
          } = s;
          if (status === 200 && data) {
            showSuccessToast('投诉成功');
          } else {
            showFailToast('投诉失败，请检查网络后重试！');
          }
        }).catch(() => {
          showFailToast('投诉失败，请检查网络后重试！');
        });
      } else {
        showFailToast('请填写投诉内容');
      }
    };
    return (_ctx, _cache) => {
      const _component_van_field = _resolveComponent("van-field");
      const _component_van_button = _resolveComponent("van-button");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("h4", null, _toDisplayString(prop.title), 1)]), _hoisted_3, _createElementVNode("div", _hoisted_4, [_createVNode(_component_van_field, {
        modelValue: message.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => message.value = $event),
        autosize: "",
        type: "textarea",
        maxlength: "200",
        placeholder: "请输入投诉内容",
        "show-word-limit": "",
        border: ""
      }, null, 8, ["modelValue"])]), _hoisted_5, _createElementVNode("div", _hoisted_6, [_createVNode(_component_van_field, {
        modelValue: phoneNo.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => phoneNo.value = $event),
        placeholder: "请输入联系方式方便我们与你沟通了解情况",
        type: "tel",
        maxlength: "11"
      }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_7, [_createVNode(_component_van_button, {
        type: "success",
        block: "",
        onClick: submit
      }, {
        default: _withCtx(() => [_createTextVNode("提交反馈")]),
        _: 1
      })])]);
    };
  }
};